import http from '@/helpers/http';

export function emptyLiveTranscript() {
  return {
    text: '',
    seq: 0,
    listening: false,
    faithful_transcript: null,
    has_recording: false,
  };
}

export function fetchLiveTranscript(professionalId, scheduleId) {
  if (!professionalId || !scheduleId) {
    return Promise.resolve(emptyLiveTranscript());
  }

  return http
    .get(`/professionals/${professionalId}/schedules/${scheduleId}/live-transcript`)
    .then((response) => ({ ...emptyLiveTranscript(), ...response.data }))
    .catch(() => emptyLiveTranscript());
}

export function subscribeLiveTranscript(scheduleId, onUpdate) {
  const echo = window.Echo;
  if (!echo || !scheduleId) {
    return () => {};
  }

  const channel = `schedules.${scheduleId}`;
  echo.private(channel).listen('LiveTranscriptUpdated', onUpdate);

  return () => {
    echo.leave(channel);
  };
}
